import moment from 'moment';
import { createRoot } from 'react-dom/client';
import React, { useCallback, useState } from 'react';
import ModifyMutualExchangeModalWrapper from './../modify-finalized-exchange/ModifyMutualExchangeModalWrapper';
import ModifyGpExchangeModalWrapper from './../modify-finalized-exchange/ModifyGpExchangeModalWrapper';
import Exchange from '../../../models/Exchange';
import Utils from '../../../utils/utils';
export var useModifyAnExchange = function (_a) {
    var _b;
    var conversation = _a.conversation, availabilities = _a.availabilities, user = _a.user, interlocutorAvailabilities = _a.interlocutorAvailabilities, fetchConversation = _a.fetchConversation;
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var updateLoadingState = function () {
        setIsLoading(false);
    };
    var getExchangeToDisplay = function () {
        if (conversation.getExchange().get('update_status') &&
            conversation.getExchange().get('update_status') === Exchange.UPDATE_STATUS_NEED_BILLING) {
            return conversation.getAllExchanges()[0];
        }
        return conversation.getExchange();
    };
    var getExchangeModificationPopupContainer = function () {
        var container = document.createElement('div');
        document.getElementsByTagName('body')[0].appendChild(container);
        return container;
    };
    var handleModifyMutualExchangeModal = function () {
        var container = getExchangeModificationPopupContainer();
        var myExchange = conversation.getExchangeAsGuest();
        var interlocutorExchange = conversation.getExchangeAsHost();
        var availableDates = availabilities === null || availabilities === void 0 ? void 0 : availabilities.filter(function (item) {
            return item.get('start_on').format('YYYY-MM-DD') !==
                moment(myExchange.get('start_on')).format('YYYY-MM-DD') &&
                item.get('end_on').format('YYYY-MM-DD') !==
                    moment(myExchange.get('end_on')).format('YYYY-MM-DD');
        });
        var interlocutorAvailabilitiesDates = interlocutorAvailabilities === null || interlocutorAvailabilities === void 0 ? void 0 : interlocutorAvailabilities.filter(function (item) {
            return item.get('start_on').format('YYYY-MM-DD') !==
                moment(interlocutorExchange.get('start_on')).format('YYYY-MM-DD') &&
                item.get('end_on').format('YYYY-MM-DD') !==
                    moment(interlocutorExchange.get('end_on')).format('YYYY-MM-DD');
        });
        // Sort exchange so your exchange appears first
        var exchanges = conversation.get('exchanges').sort(function (exchange) {
            return exchange.get('guest').id === user.id ? -1 : 1;
        });
        createRoot(container).render(React.createElement(ModifyMutualExchangeModalWrapper, { convExchanges: exchanges, convId: conversation === null || conversation === void 0 ? void 0 : conversation.get('id'), interlocutorFirstName: conversation === null || conversation === void 0 ? void 0 : conversation.get('interlocutor').get('first_name'), updateLoadingState: updateLoadingState, availabilities: availableDates, interlocutorAvailabilities: interlocutorAvailabilitiesDates, userTotalGp: parseInt(user.get('number_guestpoint'), 10), isCollection: user.isCollection(), fetchConversation: fetchConversation }));
    };
    var handleModifyGpExchangeModal = function () {
        var container = getExchangeModificationPopupContainer();
        var exchange = getExchangeToDisplay();
        var availableDates = availabilities === null || availabilities === void 0 ? void 0 : availabilities.filter(function (item) {
            return item.get('start_on').format('YYYY-MM-DD') !==
                moment(exchange.get('start_on')).format('YYYY-MM-DD') &&
                item.get('end_on').format('YYYY-MM-DD') !==
                    moment(exchange.get('end_on')).format('YYYY-MM-DD');
        });
        createRoot(container).render(React.createElement(ModifyGpExchangeModalWrapper, { convExchange: conversation === null || conversation === void 0 ? void 0 : conversation.getExchange(), convId: conversation === null || conversation === void 0 ? void 0 : conversation.get('id'), firstName: Utils.ucfirst(exchange.get('guest').get('first_name')), availabilities: availableDates, updateLoadingState: updateLoadingState, isCollection: user.isCollection(), userTotalGp: parseInt(user.get('number_guestpoint'), 10), fetchConversation: fetchConversation }));
    };
    var canModify = useCallback(function () {
        var exchangeIsMutual = conversation.isMutual();
        var exchanges = conversation.get('exchanges');
        var allExchangesAreFinalized = exchanges.every(function (exchange) { return exchange.isFinalized(); });
        var allExchangesHaveStarted = exchanges.every(function (exchange) { return exchange.isStarted(); });
        var hasBeenCanceled = exchanges.some(function (exchange) { return exchange.isCanceled(); });
        if (!allExchangesAreFinalized || allExchangesHaveStarted || hasBeenCanceled) {
            return false;
        }
        if (exchangeIsMutual) {
            var withGuestPoint = exchanges.some(function (exchange) { return exchange.get('guestpoint_amount') > 0; });
            return !withGuestPoint;
        }
        return true;
    }, []);
    var showModifyExchangeModal = useCallback(function () {
        setIsLoading(true);
        conversation.isMutual() ? handleModifyMutualExchangeModal() : handleModifyGpExchangeModal();
    }, [setIsLoading]);
    return {
        isLoading: isLoading,
        canModify: canModify,
        showModifyExchangeModal: showModifyExchangeModal,
        conversationHasModification: ((_b = conversation.getModificators()) === null || _b === void 0 ? void 0 : _b.length) !== 0
    };
};
